import axios from 'axios';
import {
  CampaignPerformanceItem,
  GlobalPerformanceItem,
  PerformanceFilterInput,
} from '../types/performance.types';

const apiUrl = process.env.REACT_APP_SIADASH_BACKEND_URL;

/**
 * Fetch campaign performance data
 * Grouped by queue/vendor with optional office filtering
 */
export const getCampaignPerformance = async (
  filter: PerformanceFilterInput
): Promise<CampaignPerformanceItem[]> => {
  const token = localStorage.getItem('accessToken');
  const response = await axios.get(`${apiUrl}/api/performance/campaign`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: filter,
  });
  return response.data;
};

/**
 * Fetch global performance data
 * Grouped by campaign (globalId)
 */
export const getGlobalPerformance = async (
  filter: PerformanceFilterInput
): Promise<GlobalPerformanceItem[]> => {
  const token = localStorage.getItem('accessToken');
  const response = await axios.get(`${apiUrl}/api/performance/global`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: filter,
  });
  return response.data;
};
